<template>
  <v-card>
    <v-toolbar flat dense>
      <v-toolbar-title>Menù composti</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Cerca nei menù"
        hide-details
        clearable
        clear-icon="mdi-close-circle-outline"
        class="mt-3"
      ></v-text-field>
      <v-btn class="ml-5" color="success" :disabled="!daSalvare" @click.stop="onSalvaModifiche">Salva modifiche</v-btn>
    </v-toolbar>
    <v-row no-gutters>
      <v-col cols="3">
        <v-card-title>
          <v-btn small title="Crea un elemento di primo livello" @click="creaElementoRoot">Crea menù composto</v-btn>
          <v-btn small icon class="ml-3" :title="expanded ? 'Collassa tutti i nodi' : 'Espandi tutti i nodi'" @click="toggleTreeview">
            <v-icon>{{ expanded ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'}}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-treeview
            :items="items"
            :search="search"
            :open.sync="open"
            dense
            hoverable

            :open-on-click="true"
            :return-object="true"
            transition
            @update:active="onItemSelected"
            @update:open="onUpdateOpen"
            ref="menuTree"
          >
          <template v-slot:label="{ item }">
            <div @click="onRowSelected(item)">{{item.name}}</div>
          </template>
            <template v-slot:append="{ item }">
              <v-btn v-if="!item.children || item.children.length === 0" icon @click.stop="deleteItem(item)" title="Cancella l'elemento"><v-icon small>mdi-delete</v-icon></v-btn>
              <v-btn v-if="item.livello < 2" icon @click.stop="onNewItem(item)" title="Aggiungi un elemento figlio" ><v-icon small>mdi-plus-circle-outline</v-icon></v-btn>
            </template>          
          </v-treeview>
        </v-card-text>
      </v-col>
      <v-col v-if="!blocco">
        <v-banner :sticky="true" style="top:30px;">
          <v-card
            class="d-flex align-center mb-6"
            flat
            height="200"
            tile
          >
            <div class="pa-2 text-h5">Scegli la voce da modificare</div>
          </v-card>
        </v-banner>
      </v-col>
      <v-col v-else>
        <v-banner :sticky="true" style="top:30px;">
          <v-card-title class="mt-5">{{ tipoBlocco(blocco) }}</v-card-title>
          <v-card-subtitle>{{ blocco.name }}</v-card-subtitle>
          <v-card-text>
            <v-row v-if="blocco.livello !== 2">
              <v-col cols="8"><v-text-field v-model="blocco.name" label="nome" hide-details clearable outlined dense @input="modificatoName(blocco)"></v-text-field></v-col>
              <v-col cols="8" v-if="blocco.livello === 0"><v-text-field v-model="blocco.codice" label="codice" :disabled="!blocco.__nuovo" hide-details clearable outlined dense @change="modificato"></v-text-field></v-col>            
              <v-col cols="8"><v-text-field v-model="blocco.descrizione" label="descrizione" hide-details clearable outlined dense @change="modificato"></v-text-field></v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="8">
                <p-prodotto :item="itemCodice(blocco)" :index="0" @change="componentValueChange" :updateTrigger="updateTrigger" :solo="false" :suTable="false" :isLotto="false" :isBom="false" :isProdottoBase="false" :clearInfo="clearInfo" :popolaInfo="popolaInfo"/>
              </v-col>
              <v-col cols="8"><v-text-field v-model="blocco.descrizione" label="descrizione" hide-details clearable outlined dense @change="modificato"></v-text-field></v-col>
            </v-row>
            <v-row v-if="blocco.livello === 0">
              <v-col cols="3"><v-text-field v-model="blocco.deltaPrezzo" label="prezzo menù" hide-details="auto" :prefix="blocco.deltaPrezzo ? '€' : ''" :suffix="prezzoLivello0(blocco)" outlined dense :rules="[numerico]" @change="modificato" /></v-col>
              <v-col cols="3"><v-text-field :value="limitePrezzi(blocco)" readonly label="prezzo calcolato" hide-details="auto" outlined dense ></v-text-field></v-col>
              <v-col cols="2"><v-switch v-model="blocco.attivo" inset dense label="menù attivo" class="ml-5 mt-0" @change="modificato"/></v-col>
            </v-row>
           <v-row v-else-if="blocco.livello === 2">
              <v-col cols="3"><v-text-field v-model="blocco.deltaPrezzo" label="delta prezzo" hide-details="auto" :prefix="triggerPrezzo && blocco.deltaPrezzo ? '€' : ''" :suffix="blocco.prezzoCalcolato ? 'L1: ' + blocco.prezzoCalcolato + ' €' : ''" outlined dense :rules="[numerico]" @change="modificato"></v-text-field></v-col>
              <v-col cols="2"><v-switch v-model="blocco.attivo" inset dense label="prodotto attivo" class="ml-5 mt-0" @change="modificato"/></v-col>
            </v-row>            
            <v-row v-else>
              <v-col cols="2"><v-text-field v-model="blocco.deltaPrezzo" label="delta prezzo" hide-details="auto" :prefix="triggerPrezzo && blocco.deltaPrezzo ? '€' : ''" outlined dense :rules="[numerico]" @change="modificato"></v-text-field></v-col>
              <v-col cols="2"><v-switch v-model="blocco.attivo" inset dense label="menù attivo" class="ml-5 mt-0" @change="modificato"/></v-col>
            </v-row>
            <v-row no-gutters v-if="blocco.livello === 1">
              <v-col class="text-caption">Il valore di delta prezzo negativo viene applicato se l'elemento è tolto dal menù</v-col>
            </v-row>
            <v-row v-if="blocco.livello === 1">
              <v-col cols="3">
                <v-select v-model="blocco.stampa" :items="stampantiComande" outlined dense label="Stampanti" multiple hint="Destinazione stampa comande" persistent-hint item-text="descrizione" item-value="codice" @change="onChangeStampa"></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-banner>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import * as dot from 'dot-object'
  import { v4 as uuidv4 } from 'uuid'
  import { calcolaHash, sanitize } from '@/components/helpers'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import prodotti from '@/services/prodottiService'
  import configurazioni from '@/services/configurazioniService'
  import pProdotto from '@/views/distintaBase/components/dettaglioDistinta/elementi/prodotto'

  export default {
    components: {
      pProdotto
    },
    /* props: [ 'menu' ], */
    mixins: [ verificaLicenza ],
    data () {
      return {
        tabs: null,
        // sezione: null,
        expanded: true,
        updateTrigger: 1,
        search: null,
        caseSensitive: false,
        open: [],
        itemsScroller: [],
          // TODO: La versione definitiva dovrebbe essere come le impostazioni di VSCode --> selezionando treeview 
          //        porta sulla voce corretta ma si può scrollare anche sulle voci precedenti
          //        La versione attuale di virtual-scroller non permette di spostarsi da codice --> non si riesce a puntare dove visualizzare
          //        Workaround: Alla selezione su treeview cambia l'elenco degli items visualizzabili
        menuComposti: [],
        blocco: null,
        struttura: null,
        daSalvare: false,
        defaultRootItem: {
          id: '',
          codice: '',
          name: '',
          descrizione: '',
          livello: 0,
          attivo: true,
          stampa: [],
          children: []
        },
        numerico: value => !value || !isNaN(value) || 'Il valore deve essere numerico',
        defaultMC: null,
        clearInfo: 1,
        popolaInfo: 1,
        elencoProdotti: [],
        elencoIds: [],
        triggerPrezzo: 1,
        stampantiComande: []
      }
    },
    beforeMount() {
      window.addEventListener("beforeunload", this.preventNav)
    },
    beforeDestroy() {
      window.removeEventListener("beforeunload", this.preventNav);
    },
    beforeRouteLeave (to, from, next) {
      if (this.modificheNonSalvate) {
        const answer = window.confirm('Ci sono delle modifiche non salvate, confermi uscita ?')
        if (!answer) return false
      }
      next()
    },
    async mounted() {
      await this.gestioneToken()
      
      const impostazioni = await configurazioni.getConfigurazione('menu')
      this.defaultMC = impostazioni.defaultMenuComposti

      // TODO: Mettere su impostazioni
      // Verificare se associare le categorie alle stampanti o le stampanti alle categorie
      this.stampantiComande = [
        { codice: "comande01", descrizione: "Stampante 01"},
        { codice: "comande02", descrizione: "Stampante 02"},
        { codice: "comande03", descrizione: "Stampante 03"}
      ]
      // const strutturaConfigurazione = await tabelle.getTabella(this.nomeTabellaStruttura)
      // const menuConfigurazione = await configurazioni.getConfigurazione('menu')
      /*
        elenco prodotti con tipoItem = menuComposto
        composizione contiene il dettaglio di ciascun menu
      */
      const menuComposti = await prodotti.getMenuComposti()
      this.menuComposti = menuComposti.docs
      this.struttura = menuComposti.docs.map(x => { return {
        id: x._id,
        codice: x.codice,
        name: x.descrizione,
        descrizione: x.menu.descrizione,
        livello: 0,
        attivo: x.menu.attivo,
        stampa: x.menu.stampa,
        children: x.menu.composizione,
        deltaPrezzo: _.get(x, 'prezzo.L1.base') || 0,
        hash: calcolaHash(x.menu),
        ordine: x.menu.ordine,
        prezzoMax: 0,
        prezzoMin: 0,
        prezzoCalcolatoMax: 0,
        prezzoCalcolatoMin: 0
      }})

      this.fixRecurse(this.struttura)
      if (this.elencoIds.length > 0) {
        this.elencoProdotti = await prodotti.getProdottiByIds(this.elencoIds)
      }
      // this.calcolaRecurse(this.struttura)
      this.calcolaPrezzi(this.struttura)

      this.struttura = _.sortBy(this.struttura, "ordine")
      console.log(this.struttura)
    },
    computed: {
      items() {
        return this.struttura || []
      },
      modificheNonSalvate() {
        return this.daSalvare
      }
    },
    methods: {
      toggleTreeview() {
        this.expanded = !this.expanded;
        this.$refs.menuTree.updateAll(this.expanded); 
      },
      tipoBlocco(blocco) {
        switch(blocco.livello) {
          case 0:
            return 'Menù'
          case 1:
            return 'Gruppo'
          case 2:
            return 'Ingrediente'
          default:
            return ''
        }
      },
      creaElementoRoot() {
        let el = JSON.parse(JSON.stringify(this.defaultRootItem))
        el.name = `Nuovo Menu ${this.struttura.length + 1}`
        el.codice = sanitize(el.name, true)
        el.id = uuidv4()
        el.__nuovo = true
        this.struttura.push(el)
        this.daSalvare = true
        const item = this.struttura.find(x => x.id === el.id)
        this.onRowSelected(item)
      },
      modificato() {
        this.calcolaPrezzi(this.struttura)
        this.daSalvare = true
        this.triggerPrezzo++
      },
      modificatoName(item) {
        if (item.livello === 0) {
          item.codice = sanitize(item.name, true)
          item.id = item.codice
        }
        this.daSalvare = true
      },
      pushIfNotExists(item) {
        if (!this.elencoIds.includes(item)) {
          this.elencoIds.push(item)
        }
      },
      fixRecurse(items, parentId) { // inserisce parentId se non esiste
        for (let el of items) {
          if (el.livello === 2) {
            this.pushIfNotExists(el.codice)
          }
          if (!el.parentId) {
            el.parentId = parentId
          }
          if (el.children) {
            this.fixRecurse(el.children, el.id)
          }
        }
      },
      prezzoLivello0(bl, triggerPrezzo) {
        const min = bl.prezzoMin ? 'min: ' + bl.prezzoMin + '€' : ''
        const max = bl.prezzoMax ? 'max: ' + bl.prezzoMax + '€' : ''
        return this.triggerPrezzo && (min + ' - ' + max)
      },
      limitePrezzi(bl) {
        const min = bl.prezzoCalcolatoMin ? 'min: ' + bl.prezzoCalcolatoMin + '€' : ''
        const max = bl.prezzoCalcolatoMax ? 'max: ' + bl.prezzoCalcolatoMax + '€' : ''
        return min + ' - ' + max
      },
      calcolaPrezzi(elencoMenu) {
        console.log('calcolaPrezzi')
        for (let m of elencoMenu) {
          // per ogni menu ciclo i gruppi
          let prezzoMax = 0
          let prezzoMin = 0
          let prezzoCalcolatoMax = 0
          let prezzoCalcolatoMin = 0
          for (let g of m.children) {
            // per ogni gruppo ciclo i prodotti
            let maxP = 0
            let minP = 1000
            let maxC = 0
            let minC = 1000
            for (let p of g.children) {
              const pr = this.elencoProdotti.find(x => x._id === p.codice || x.id === p.codice)
              if (pr) {
                p.prezzoCalcolato = parseFloat(_.get(pr, 'prezzo.L1.base') || 0)
                if (p.prezzoCalcolato > maxC) {
                  maxC = p.prezzoCalcolato
                }
                if (p.prezzoCalcolato < minC) {
                  minC = p.prezzoCalcolato
                } 

                const dp = parseFloat(p.deltaPrezzo || 0)
                if (dp > maxP) {
                  maxP = dp
                }
                if (dp < minP) {
                  minP = dp
                }                
              }
            }
            const gdp = parseFloat(g.deltaPrezzo || 0)
            g.maxP = maxP + (gdp > 0 ? gdp : 0)
            g.minP = minP + (gdp < 0 ? gdp : 0)
            prezzoMax = prezzoMax + g.maxP
            prezzoMin = prezzoMin + g.minP

            if (minC === 1000) minC = 0
            g.minC = minC
            g.maxC = maxC
            prezzoCalcolatoMax = prezzoCalcolatoMax + g.maxC
            prezzoCalcolatoMin = prezzoCalcolatoMin + g.minC
          }
          m.prezzoMax = +(parseFloat(m.deltaPrezzo) + parseFloat(prezzoMax)).toFixed(2)
          m.prezzoMin = +(parseFloat(m.deltaPrezzo) + parseFloat(prezzoMin)).toFixed(2)

          m.prezzoCalcolatoMax = +prezzoCalcolatoMax.toFixed(2)
          m.prezzoCalcolatoMin = +prezzoCalcolatoMin.toFixed(2)
        }
      },
      // NON USATA --> vedi calcolaPrezzi
      calcolaRecurse(items) { // calcola i costi massimi e reali
        // let deltaPrezzo = prezzo || 0
        let prezzoMax = 0
        let prezzoCalcolato = 0
        let deltaPrezzo = 0
        console.log('delta0', deltaPrezzo)
        // let prezzoCalcolatoMax = 0
        for (let el of items) {
          deltaPrezzo = parseFloat(el.deltaPrezzo || 0)
          if (el.children) {
            const result = this.calcolaRecurse(el.children)
            deltaPrezzo += result.prezzoMax
            prezzoCalcolato += result.prezzoCalcolato
          }
          console.log('delta1', el.codice, deltaPrezzo)
          if (deltaPrezzo > prezzoMax) prezzoMax = deltaPrezzo
          if (el.livello === 2) {
            const pr = this.elencoProdotti.find(x => x._id === el.codice || x.id === el.codice)
            if (pr) {
              prezzoCalcolato = _.get(pr, 'prezzo.L1.base') || 0
            }
          }
          if (el.livello === 0) {
            el.prezzoMax = +(el.deltaPrezzo + prezzoMax).toFixed(2)
            el.prezzoCalcolato = +prezzoCalcolato.toFixed(2)
            el.prezzoCalcolatoMax = +(prezzoCalcolato + prezzoMax).toFixed(2)
          }
        }
        console.log('deltaPrezzo2, prezzoMax, prezzoCalcolato', deltaPrezzo, prezzoMax, prezzoCalcolato)
        return { prezzoMax, prezzoCalcolato }
      },      
      findRecurse(items, id) {
        var item
        for (let el of items) {
          if (el.id === id) {
            item = el
          } else {
            if (el.children) {
              item = this.findRecurse(el.children, id)
            }
          }
          if (item) {
            break
          }
        }
        return item
      },
      deleteItem(item) {
        const answer = window.confirm('Confermi cancellazione elemento ?')
        if (!answer) return false
        if (!item.parentId) {
          let elx = this.struttura.findIndex(x => x.id === item.id)
          if (elx !== -1) {
            this.struttura.splice(elx, 1)
          }
        } else {
          let parent = this.findRecurse(this.struttura, item.parentId)
          let elx = (parent.children).findIndex(x => x.id === item.id)
          console.log(elx)
          parent.children.splice(elx, 1)
        }
        this.daSalvare = true
      },
      onChangeStampa() {
        this.daSalvare = true
      },
      onNewItem(item) {
        let el = JSON.parse(JSON.stringify(this.defaultRootItem))
        el.name = `Nuovo Elemento ${item.children.length + 1}` // TODO: Prendere il valore dell'ultimo, altrimenti errore se cancello un elemento e ricreo
        el.id = uuidv4()
        el.parentId = item.id
        el.livello = item.livello + 1
        item.children.push(el)
        this.daSalvare = true
        const newItem = item.children.find(x => x.id === el.id)
        
        this.open.push(item)
        this.onUpdateOpen(this.open)
        this.onRowSelected(newItem)
      },
      preventNav(event) {
        if (!this.modificheNonSalvate) return
        event.preventDefault()
        event.returnValue = ""
      },  
      async onSalvaModifiche() {
        let sIdx = 0
        for (let s of this.struttura) {
          delete s.__nuovo
          // Verificare anche il prezzo del menu --> da riportare su prezzo.L1.base
          let mc = this.menuComposti.find(x => x._id === s.id)
          if (mc) {
            const hash = calcolaHash(s)
            if (s.hash !== hash) {
              console.log('salvare')
              let prodotto = await prodotti.getProdotto(mc._id)
              _.set(prodotto, 'prezzo.L1.base', parseFloat(s.deltaPrezzo || 0))
              _.set(prodotto, 'menu.composizione', s.children)
              _.set(prodotto, 'menu.descrizione', s.descrizione || '')
              _.set(prodotto, 'menu.stampa', s.stampa || [])
              _.set(prodotto, 'menu.attivo', s.attivo)
              _.set(prodotto, 'menu.ordine', s.ordine || sIdx)
              await prodotti.aggiornaProdotto(prodotto)           
            }
          } else {
            let prodotto = await prodotti.getModello('menucomposto') // non torna corretto
            prodotto = { ...prodotto, ...this.defaultMC }
            prodotto.codice = s.codice || sanitize(s.name, true)
            prodotto._id = prodotto.codice
            prodotto.descrizione = s.name || ''
            _.set(prodotto, 'prezzo.L1.base', parseFloat(s.deltaPrezzo || 0))
            _.set(prodotto, 'menu.composizione', s.children)
            _.set(prodotto, 'menu.descrizione', s.descrizione || '')
            _.set(prodotto, 'menu.stampa', s.stampa || [])
            _.set(prodotto, 'menu.attivo', s.attivo)
            _.set(prodotto, 'menu.ordine', s.ordine || sIdx)
            await prodotti.creaProdotto(prodotto)               
          }
          sIdx++
        }
        this.daSalvare = false
      },
      async onItemSelected(elementi) {
        let el = elementi && elementi.length > 0 ? elementi[0] : {}
        if (!_.isEmpty(el)) {
          this.onRowSelected(el)
        }
      },
      onUpdateOpen(elementi) {
        this.expanded = elementi.length > 0
      },
      onRowSelected(item) {
        if (item) {
          this.tabs = 0
          this.blocco = item
        } else {
          this.blocco = null
        }
        this.clearInfo++
        this.popolaInfo++
      },
     itemCodice(item) {
        return {
          "model": "codice",
          "valueField": "codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.codice) || ''
        }
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, item } = data
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        let aggionePrezzi = false
        if (!this.blocco.codice || (tgt.codice && this.blocco.codice !== tgt.codice)) {
          if (!this.elencoProdotti.find(x => x._id === item.id)) {
            this.elencoProdotti.push(item)
          }
          aggionePrezzi = true
          /* this.calcolaPrezzi(this.struttura)
          this.triggerPrezzo++ */
        }
        _.merge(this.blocco, tgt)
        await this.aggiornaCorrelati(data, aggionePrezzi)
        this.daSalvare = true // TODO: solo nel caso di modifiche reali
      },
      async aggiornaCorrelati(data, aggionePrezzi) {
        switch (data.model) {
          case 'codice':
            if (data.value !== undefined) {
              this.blocco.descrizione = _.get(data, 'item.descrizione', '')
              this.blocco.codice = _.get(data, 'item.codice', '')
              this.blocco.name = _.get(data, 'item.descrizione', '')
              this.blocco.unitaMisura = _.get(data, 'item.item.magazzino.unitaMisura', '')
              this.blocco.presenzaVariazioni = _.get(data, 'item.item.presenzaVariazioni', false)
              console.log('presenzaVariazioni', data, this.blocco)
              this.updateTrigger++
/*               if (data && data.value && (!this.blocco.codice || this.blocco.codice !== data.value)) {
                if (!this.elencoProdotti.find(x => x._id === data.item.id)) {
                  this.elencoProdotti.push(data.item)
                }
              } */
              if (aggionePrezzi) {
                this.calcolaPrezzi(this.struttura)
              }
              this.triggerPrezzo++
            }
            break
          default:
            break
        }
      }      
    }
  }
</script>

<style lang="scss" scoped>
  .sticky-component {
    position: -webkit-sticky;
    position: sticky;
    top: 20px;
  }
</style>
